module.exports = __webpack_public_path__ + "img/tomcat.cdc6a639.svg";